import { envProblems } from '@/lib/env';

export function ConfigError() {
  return (
    <main className="grid min-h-screen place-items-center px-6 py-16">
      <div className="w-full max-w-xl border border-brand-line bg-ink p-8">
        <p className="sig text-4xl text-cream">Nikita Kering'</p>
        <h1 className="mt-4 font-serif text-2xl">Store is not configured</h1>
        <p className="mt-2 text-sm text-brand-muted">
          The build is missing environment variables. Copy <code>.env.example</code> to{' '}
          <code>.env.local</code> and fill in the Supabase project values.
        </p>
        <ul className="mt-5 grid gap-2 border border-brand-line bg-night p-4 font-mono text-xs text-brand-danger">
          {envProblems.map((problem) => (
            <li key={problem}>{problem}</li>
          ))}
        </ul>
      </div>
    </main>
  );
}
